import 'antd/dist/reset.css'
import 'flag-icons/css/flag-icons.min.css'
import './index.scss'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import { Compose } from 'shared/components/Compose'
import { BrowserRouter } from 'react-router-dom'
import { LoaderContextProvider } from 'core/context/Loader/LoaderContextProvider'
import { AccountContextProvider } from 'core/context/Account/AccountContextProvider'
import { ConfigProvider } from 'antd'
import en from 'antd/lib/locale/en_US'
import enDayjs from 'dayjs/locale/en'
import dayjs from 'dayjs'
import { registerServiceWorker } from './serviceWorkerRegistration'

dayjs.locale(enDayjs)
registerServiceWorker()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
    <ConfigProvider
        locale={en}
        theme={{
            token: {
                // Синий чуть глубже стандартного #1890ff: белый текст на
                // кнопках и ссылки на белом проходят контраст WCAG AA (6:1
                // вместо 3.2:1).
                colorPrimary: '#0958d9',
            },
        }}
    >
        <Compose
            components={[
                BrowserRouter,
                LoaderContextProvider,
                AccountContextProvider,
            ]}
        >
            <App />
        </Compose>
    </ConfigProvider>
)
